import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { StorageKeys } from '@core/storage/storage.keys';
import { UserState } from '@core/user/user.state';
import { LocalStorageService } from 'ngx-webstorage';
import { Observable } from 'rxjs';

export function authTokenInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const authToken: string = inject(UserState).authToken;
    const injector: Injector = inject(Injector);
    const currentLanguage: string = injector.get(LocalStorageService).retrieve(StorageKeys.Lang);

    if (req.url.includes('/api')) {
        const modifiedReq = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${authToken}`),
            params: req.params.set('lang', currentLanguage),
        });

        return next(modifiedReq);
    }

    return next(req);
}
